import { http } from "./http.js";

async function getCountry(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    prefix: response.data.Prefix,
    isoCode: response.data.IsoCode,
    inputLanguage: response.data.InputLanguage,
    isRemoved: response.data.IsRemoved,
    isConfirmed: response.data.IsConfirmed,
  };
}

async function updateCountry(resource, id, entity) {
  const response = await http.put(`/${resource}/${id}`, entity);
  return response.data;
}

async function createCountry(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}

async function changeRemovedState(resource, entity) {
  const response = await http.patch(
    `/${resource}/${entity.id}/rpc/change-removed-state`,
    {
      value: !entity.isRemoved,
    },
  );
  return response;
}

async function deleteCountry(resource, id) {
  const response = await http.delete(`${resource}/${id}`);
  return response;
}

async function getCountryReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    inputLanguage: response.data.InputLanguage,
  };
}

async function fetchCountries(resource) {
  const response = await http.get(`${resource}/referencies`);
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
      inputLanguage: i.InputLanguage,
    };
  });
}

async function searchReferencies(resource, search) {
  const response = await http.get(
    `${resource}/referencies?searchTerm=${search}`,
  );
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
        inputLanguage: i.InputLanguage,
      };
    });
  } else {
    response.data = [];
    return response;
  }
}

async function getUkraine() {
  const response = await http.get("countries/ukraine");
  return response.data;
}

export {
  getCountry,
  updateCountry,
  createCountry,
  changeRemovedState,
  deleteCountry,
  getCountryReference,
  fetchCountries,
  searchReferencies,
  getUkraine,
};
